import { render } from "./HelpRequestButton.vue?vue&type=template&id=05c94f98&scoped=true"
import script from "./HelpRequestButton.vue?vue&type=script&lang=js"
export * from "./HelpRequestButton.vue?vue&type=script&lang=js"

import "./HelpRequestButton.vue?vue&type=style&index=0&id=05c94f98&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c94f98"]])

export default __exports__